var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCapitalHumano(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.627,
    height: 137.627,
    viewBox: "0 0 137.627 137.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5023",
    "data-name": "Path 5023",
    d: "M184.024,754.484a2.15,2.15,0,0,0,0,4.3h11.5a2.15,2.15,0,0,0,0-4.3Z",
    transform: "translate(-181.874 -754.484)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.99,
    y1: 108.605,
    x2: -3.968,
    y2: 108.605,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc14b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5024",
    "data-name": "Path 5024",
    d: "M535.334,754.484a2.15,2.15,0,1,0,0,4.3h11.5a2.15,2.15,0,0,0,0-4.3Z",
    transform: "translate(-533.183 -754.484)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -11.698,
    y1: 108.605,
    x2: -11.676,
    y2: 108.605,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5025",
    "data-name": "Path 5025",
    d: "M374.118,564.393v11.5a2.15,2.15,0,1,0,4.3,0v-11.5a2.15,2.15,0,1,0-4.3,0",
    transform: "translate(-374.118 -562.242)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -30.166,
    y1: 33.771,
    x2: -30.085,
    y2: 33.771,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5026",
    "data-name": "Path 5026",
    d: "M374.118,915.7v11.5a2.15,2.15,0,1,0,4.3,0V915.7a2.15,2.15,0,1,0-4.3,0",
    transform: "translate(-374.118 -913.551)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -30.166,
    y1: 26.063,
    x2: -30.085,
    y2: 26.063,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5027",
    "data-name": "Path 5027",
    d: "M238.79,619.192a2.158,2.158,0,0,0,0,3.054L255.2,638.621a2.15,2.15,0,0,0,3.032-3.031l-16.386-16.4a2.16,2.16,0,0,0-3.054,0",
    transform: "translate(-238.157 -618.56)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.92,
    y1: 24.732,
    x2: -3.903,
    y2: 24.732,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5028",
    "data-name": "Path 5028",
    d: "M463.734,844.1a2.15,2.15,0,0,0-.112,2.919L480.009,863.4h0a2.159,2.159,0,1,0,3.054-3.054l-16.407-16.364a2.15,2.15,0,0,0-2.919.112",
    transform: "translate(-463.105 -843.469)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -7.631,
    y1: 20.995,
    x2: -7.615,
    y2: 20.995,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5029",
    "data-name": "Path 5029",
    d: "M479.547,619.157l.022.011-16.386,16.4a2.15,2.15,0,1,0,3.031,3.032L482.6,622.21h0a2.159,2.159,0,1,0-3.054-3.054",
    transform: "translate(-462.43 -618.524)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -7.622,
    y1: 24.669,
    x2: -7.606,
    y2: 24.669,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5030",
    "data-name": "Path 5030",
    d: "M255.219,843.987l-16.4,16.385a2.159,2.159,0,0,0,3.054,3.054l16.375-16.407a2.15,2.15,0,0,0-3.032-3.031",
    transform: "translate(-238.19 -843.469)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -3.923,
    y1: 20.973,
    x2: -3.906,
    y2: 20.973,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5031",
    "data-name": "Path 5031",
    d: "M426.337,699.159a4.516,4.516,0,0,1,.028-9.032h0a4.516,4.516,0,0,1-.02,9.032h-.007m-6.222-10.766a8.84,8.84,0,1,0,6.249-2.588,8.842,8.842,0,0,0-6.249,2.588",
    transform: "translate(-417.527 -685.805)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -8.191,
    y1: 27.772,
    x2: -8.171,
    y2: 27.772,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5032",
    "data-name": "Path 5032",
    d: "M298.83,697.843a4.519,4.519,0,0,1,3.186-7.716h0a4.516,4.516,0,0,1,.007,9.031h-.007a4.515,4.515,0,0,1-3.187-1.316m3.194-12.038a8.837,8.837,0,1,0,6.252,2.588,8.838,8.838,0,0,0-6.252-2.588h0",
    transform: "translate(-293.189 -685.805)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -5.75,
    y1: 27.768,
    x2: -5.731,
    y2: 27.768,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5033",
    "data-name": "Path 5033",
    d: "M286.366,746.7c-9.473,0-17.2,7.322-17.2,16.322,0,1.968,1.075,4.677,6.139,6.452h0a34.956,34.956,0,0,0,11.032,1.581h.291a19.753,19.753,0,0,1,1.075-4.3H286.29c-7.935-.022-12.828-2.183-12.828-3.732,0-6.623,5.773-12.01,12.9-12.01a13.141,13.141,0,0,1,10.526,5.118,21.763,21.763,0,0,1,3.988-1.8,17.386,17.386,0,0,0-14.391-7.634h-.123",
    transform: "translate(-269.162 -746.702)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2.943,
    y1: 19.238,
    x2: -2.932,
    y2: 19.238,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5034",
    "data-name": "Path 5034",
    d: "M415.613,746.7a17.381,17.381,0,0,0-14.515,7.634,21.791,21.791,0,0,1,3.988,1.8,13.139,13.139,0,0,1,10.527-5.118c7.1,0,12.9,5.376,12.9,12.01,0,1.548-4.892,3.709-12.9,3.709H414.2a19.766,19.766,0,0,1,1.075,4.3h.29c7.989.011,17.247-2.1,17.247-8.01h0c0-9-7.709-16.322-17.2-16.322Z",
    transform: "translate(-401.098 -746.7)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -4.385,
    y1: 19.268,
    x2: -4.374,
    y2: 19.268,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5035",
    "data-name": "Path 5035",
    d: "M335.533,794.1c0-6.623,5.774-12.01,12.9-12.01s12.9,5.376,12.9,12.01c-.042,1.549-4.934,3.709-12.9,3.709s-12.9-2.15-12.9-3.709m12.9-16.322c-9.473,0-17.2,7.322-17.2,16.322,0,1.968,1.076,4.677,6.139,6.451h0a34.917,34.917,0,0,0,11.031,1.58c7.924,0,17.2-2.151,17.2-8.021,0-9.011-7.677-16.333-17.171-16.333Z",
    transform: "translate(-331.232 -777.773)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3.341,
    y1: 18.796,
    x2: -3.331,
    y2: 18.796,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5036",
    "data-name": "Path 5036",
    d: "M361.146,728.92a4.516,4.516,0,1,1,3.2,1.312h-.018a4.519,4.519,0,0,1-3.184-1.312m-3.045-9.454a8.838,8.838,0,1,0,6.26-2.588h-.01a8.837,8.837,0,0,0-6.25,2.588",
    transform: "translate(-355.512 -716.878)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -6.969,
    y1: 27.142,
    x2: -6.95,
    y2: 27.142,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2158",
    "data-name": "Group 2158",
    transform: "translate(9613.019 -1117.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112",
    transform: "translate(-9613.019 1184.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 15.805,
    height: 4.301,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114",
    transform: "translate(-9491.197 1184.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 15.806,
    height: 4.301,
    transform: "translate(0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116",
    transform: "translate(-9546.355 1117.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2115",
    "data-name": "Group 2115",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 4.301,
    height: 15.805,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118",
    transform: "translate(-9546.355 1239.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 4.301,
    height: 15.806,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120",
    transform: "translate(-9593.502 1137.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 21.015,
    height: 20.792,
    transform: "translate(-0.211 0)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122",
    transform: "translate(-9515.498 1214.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 21.015,
    height: 20.778,
    transform: "translate(-0.214 0)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124",
    transform: "translate(-9515.731 1136.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 21.035,
    height: 20.846,
    transform: "translate(-0.021 0)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126",
    transform: "translate(-9593.49 1214.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 21.003,
    height: 20.8,
    transform: "translate(-0.211)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128",
    transform: "translate(-9531.303 1160.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_896",
    "data-name": "Rectangle 896",
    width: 17.677,
    height: 17.677,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130",
    transform: "translate(-9574.419 1160.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 17.68,
    height: 17.679,
    transform: "translate(-0.002 0)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2132",
    "data-name": "Group 2132",
    transform: "translate(-9582.75 1181.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2131",
    "data-name": "Group 2131",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 31.719,
    height: 24.42,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134",
    transform: "translate(-9537 1181.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 31.719,
    height: 24.384,
    transform: "translate(0 -0.041)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(-9561.227 1192.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 34.375,
    height: 24.421,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138",
    transform: "translate(-9552.808 1171.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_901",
    "data-name": "Rectangle 901",
    width: 17.688,
    height: 17.69,
    transform: "translate(-0.003 0)",
    fill: "url(#linear-gradient-14)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitalHumano);
export default __webpack_public_path__ + "static/media/capital-humano.fa92ff00e70433988c381024cb971b80.svg";
export { ForwardRef as ReactComponent };